// @hyphesync/shared — Zod schemas and types shared by apps/api and the SPAs.
//
// Consumed as TypeScript SOURCE everywhere (package.json `exports` → ./src/index.ts, and
// tsconfig.base.json `paths`). There is deliberately no build step and no dist/: SunshineBids
// resolved its shared package through a gitignored dist in tsc but through src in vitest/vite,
// and a stale dist made the typecheck lie (its S264). One specifier, one file.
import { z } from "zod";

/** Every provider a connector can speak (plan §5). AEMP ships disabled in M1 (D7). */
export const PROVIDERS = ["geotab", "vermeerone", "maintainx", "aemp"] as const;
export const ProviderSchema = z.enum(PROVIDERS);
export type Provider = z.infer<typeof ProviderSchema>;

export const ENVIRONMENTS = ["dev", "prod"] as const;
export type Environment = (typeof ENVIRONMENTS)[number];

/** GET /api/health — shallow liveness; touches no binding, carries no tenant data. */
export const HealthResponseSchema = z.object({
  ok: z.literal(true),
  service: z.literal("hyphesync-api"),
  environment: z.enum(ENVIRONMENTS),
  version: z.string().max(32),
});
export type HealthResponse = z.infer<typeof HealthResponseSchema>;
